var lockScroll = {
	pos : null,
	stat : false,
}

lockScroll.init = function(lock) {
	if (lock == true) {
		lockScroll.stat = true;
		lockScroll.pos = $(window).scrollTop();
		$('#container').addClass('sticky').css({'top' : -Math.abs(lockScroll.pos)});
	} else {
		lockScroll.stat = false;
		$('#container').removeClass('sticky').removeAttr('style');
		$(window).scrollTop(lockScroll.pos);
	}
}

export { lockScroll }
